
export default {
  isochronesDetails: {
    polygons: 'Polígonos',
    center: 'Centro',
    reachCenters: 'Centros de alcance',
    toggleVisibility: 'Alternar visibilidade',
    opacity: 'Opacidade'
  }
}
